import { Geocoder } from './geocoder';
import WKT from 'ol/format/WKT.js';

const URL = "https://api.pdok.nl/bzk/locatieserver/search/v3_1"
const ROWS = 10;
const BRON = `bron:(BAG OR NWB OR BAG/NWB OR Bestuurlijke Grenzen OR CBS)`

class PDOKGeocoder extends Geocoder {
	
	constructor() {
		super();
		this.wkt = new WKT();
	}
	
	async search(query) {
		const [lon, lat] = this.getCenter();
		const url = `${URL}/free?q=${query}&rows=${ROWS}&lat=${lat}&lon=${lon}&fq=${BRON}&fl=weergavenaam geometrie_ll boundingbox_ll`

		const result = await fetch(url)
		
		const json = await result.json();
		const values = json.response.docs;
		
		return values.map(value => this.createRecord(value));		
	}
	
	geometry( record ) {
		const { geometry } = record;		
		const point = this.wkt.readGeometry(geometry, {
			dataProjection: this.wgs84,
			featureProjection: this.projection
		});	
		
		return point;
	}	
		
	createRecord(record) {
		const {weergavenaam, geometrie_ll } = record;		
		return this.create(weergavenaam, geometrie_ll);
	}
}

export { PDOKGeocoder }